import { AfterViewInit, Component, OnInit, Renderer2, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { Use, Province, City, District } from '../../interfaces/prop.interface';
import { PropertiespreService } from '../../services/propertiespre.service';

// PRELOAD JSON DATA
import { usesJson } from '../../data/uses.json';
import { provincesJson } from '../../data/provinces.json';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { filter, NEVER, Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { citiesJson } from '../../data/cities.json';

@Component({
  selector: 'app-propertiespre',
  templateUrl: './propertiespre.component.html',
  styleUrls: ['./propertiespre.component.css']
})
export class PropertiespreComponent implements OnInit, AfterViewInit {

  filteredProvinces: Observable<any> | undefined;
  filteredCities: Observable<any> | undefined;

  uses: Use[] = usesJson;
  provinces: Province[] = [];
  cities: City[] = [];
  districts: District[] = [];
  found: number = 0;
  props: any;
  isSearch4: string = '2'; // 1 Venta / 2 Alquiler / 3 Alquiler con opción a venta

  codeValue: string = "";

  myForm: FormGroup = this.fb.group({
    isSearchFor: ['Alquilar'],
    use: ['0'],
    province: [{ value: '', disabled: false }],
    city: [{ value: '', disabled: true }],
    district: [{ value: '', disabled: true }],
  })

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private propertiespreService: PropertiespreService,
    private renderer: Renderer2,
    private elRef: ElementRef
  ) { }

  ngAfterViewInit(): void {
    var myMagicPill = new magicLine(
      document.querySelectorAll('.magic-line-menu-pill'),
      {
        mode: 'pill',
        animationCallback: function (el, params) {
          anime({
            targets: el,
            left: params.left,
            top: params.top,
            width: params.width,
            height: params.height
          });
        }
      }
    );
    myMagicPill.init();
    var myMagicLine = new magicLine(
      document.querySelectorAll('.magic-line-menu'),
      {
        mode: 'line',
        animationCallback: function (el, params) {
          anime({
            targets: el,
            left: params.left,
            top: params.top,
            width: params.width,
            height: params.height
          });
        }
      }
    );
    myMagicLine.init();

    const element = this.elRef.nativeElement.querySelector('.mat-form-field-infix');
    if (element) {
      this.renderer.setStyle(element, 'width', '180px');
      // Puedes agregar más cambios de estilo si lo deseas
    }

  }
  private _filterProvinces(name: string): Province[] {
    const filterValue = name.toLowerCase();

    return this.provinces.filter(option => option.name.toLowerCase().includes(filterValue));
  }
  private _filterCities(name: string): Province[] {
    const filterValue = name.toLowerCase();

    return this.cities.filter(option => option.name.toLowerCase().includes(filterValue));
  }
  displayFnProvince(id): string {
    if (!id) return '';
    let index = this.provinces.findIndex(state => state.id === id);
    return this.provinces[index].name;
  }
  displayFnCity(id): string {
    if (!id) return '';
    let index = this.cities.findIndex(state => state.id === id);
    return this.cities[index].name;
  }


  ngOnInit(): void {

    this.filteredProvinces = this.myForm.get('province')?.valueChanges.pipe(
      startWith(''),
      map(value => {
        return (typeof value === 'string' ? value : value.id)
      }),
      map(name => (name ? this._filterProvinces(name) : this.provinces.slice())),
    );

    this.filteredCities = this.myForm.get('city')?.valueChanges.pipe(

      startWith(''),
      map(value => {
        return (typeof value === 'string' ? value : value.id)
      }),
      map(name => (name ? this._filterCities(name) : this.cities.slice())),
    );

    this.myForm.statusChanges
      .pipe(
        filter((status: string) => {
          return this.myForm.valid
        }))
      .subscribe(() => this.onFormValid());

    this.uses = this.propertiespreService.getUses();

    // Get All Provinces
    // this.propertiespreService.getProvinces().subscribe(provinces => {
    //   this.provinces = provinces.data.provinces;
    // })


    // this.provinces = this.propertiespreService.getProvinces();

    // Limit Provinces to Use an use id
    // this.propertiespreService.getProvincesByUse('1', '5').then((data: any) => {
    //   this.provinces = data;
    //   console.log(this.provinces)
    // });

    this.changeIsSearchFor()
    this.changeUse()
    this.changeProvince()
    this.changeCity()

  }


  // PRIVATE METHODS
  clearUse() {
    this.myForm.controls['province'].setValue('');
    this.myForm.controls['city'].setValue('');
    this.myForm.controls['district'].setValue('');
    this.myForm.get('use')?.enable();
    this.myForm.get('province')?.disable();
    this.myForm.get('city')?.disable();
    this.myForm.get('district')?.disable();
    this.found = 0;
  }

  clearProvince() {
    this.myForm.controls['province'].setValue('');
    this.myForm.controls['city'].setValue('');
    this.myForm.controls['district'].setValue('');
    this.myForm.get('use')?.enable();
    this.myForm.get('city')?.disable();
    this.myForm.get('district')?.disable();
    this.found = 0;
  }
  clearCity() {
    this.myForm.controls['city'].setValue('');
    this.myForm.controls['district'].setValue('');
    // this.myForm.get('use')?.enable();
    // this.myForm.get('province')?.enable();
    // this.myForm.get('city')?.enable();
    this.myForm.get('district')?.disable();
    this.found = 0;
  }



  changeSearch4() {
    // this.myForm.controls['use'].setValue('');
    // this.myForm.reset();
    this.myForm.get('use')?.enable();
    this.myForm.get('province')?.disable();
    this.myForm.get('city')?.disable();
    this.myForm.get('district')?.disable();
    this.find();
  }

  changeUse() {

    this.provinces = [];

    this.myForm.get('use')?.valueChanges.subscribe(use => {
      this.myForm.controls['province'].setValue('');
      // Limit Provinces to Use an use id
      this.propertiespreService.getProvincesByUse(this.isSearch4, use)
        .subscribe({
          next: (data: any) => {
            if (data.length > 0) {
              this.provinces = data;
              this.myForm.get('province')?.enable();
            } else {
              this.provinces = [];
              this.myForm.get('province')?.disable();
            }
          },
          error: (err: any) => { }
        })
      this.myForm.controls['city'].setValue('');
      this.myForm.get('city')?.disable();
    })

  }

  changeProvince() {

    this.myForm.get('province')?.valueChanges.subscribe(province => {

      if (this.provinces.some(x => x.id === this.myForm.get('province')?.value)) {
        this.myForm.controls['city'].setValue('');
        this.myForm.controls['district'].setValue('');

        this.propertiespreService.getCitiesByUse(province, this.isSearch4, this.myForm.get('use')?.value)
          .subscribe({
            next: (data: any) => {
              if (data.length > 0) {
                this.cities = data;
                this.myForm.get('city')?.enable();
              } else {
                this.cities = []
                this.myForm.get('city')?.disable();
              }
            },
            error: (err: any) => {
              this.cities = []
              this.myForm.get('city')?.disable();
              console.log(err);
            }
          });

      }


    })
    this.myForm.controls['district'].setValue('');
    this.myForm.get('district')?.disable();


  }
  changeCity() {

    this.myForm.get('city')?.valueChanges.subscribe(city => {

      if (this.cities.some(x => x.id === this.myForm.get('city')?.value)) {
        this.propertiespreService.getDistricts(city)
          .subscribe({
            next: (data: any) => {
              if (data.length > 0) {
                this.districts = [];
                // this.districts = data;

                // Recorremos todas las propiedades encontradas
                for (const prop of this.props.rows) {
                  // Si la city no está en el array subCities, la añade
                  if (data.find(district => district.id === prop.district.toString())) {
                    if (!this.districts.includes(data.find(district => district.id === prop.district.toString()))) {
                      this.districts.push(data.find(district => district.id === prop.district.toString()));
                    }
                  }
                }
                // console.log(this.districts)
                // this.districts.push(data.find(district => district.id === prop.district.toString()));

                // Recorremos el array de subCities
                // Por cada city, obtenemos toda la información

                // for (const cit of this.subCities) {
                //   // Por cada provincia, obtenemos toda la información

                //   this.cities3.push(this.cities2.find(city => city.id == cit.toString()))
                //   i++;
                //   if (i === this.subCities.length) {
                //     this.cities3.sort((a, b) => (a.name! < b.name! ? -1 : 1))
                //   }

                // }




                this.myForm.get('district')?.enable();
              } else {
                this.districts = []
                this.myForm.get('district')?.disable();
              }
            },
            error: (err: any) => {
              this.districts = []
              this.myForm.get('district')?.disable();
              console.log(err);
            }
          });

      }



    })


  }
  private onFormValid() {

    this.find()

  }
  find() {
    if ((this.provinces.some(x => x.id === this.myForm.get('province')?.value))) {

      this.propertiespreService.getPropsCount(this.isSearch4, this.myForm.get('use')?.value || 0, this.myForm.get('province')?.value, this.myForm.get('city')?.value, this.myForm.get('district')?.value).subscribe({
        next: (data: any) => {
          this.found = data.count;
          this.props = data;
        },
        error: (err: any) => {
          console.log(err);
        }

      })

    }


    // this.found = this.propertiespreService.getPropsCount(this.isSearch4, this.myForm.get('use')?.value, this.myForm.get('province')?.value, this.myForm.get('city')?.value, this.myForm.get('district')?.value);
  }
  change2Rent() {
    this.isSearch4 = '2';
    this.changeSearch4()
  }
  change2Buy() {
    this.isSearch4 = '1';
    this.changeSearch4()
  }

  changeIsSearchFor() {
    this.myForm.get('isSearchFor')?.valueChanges.subscribe(isSearchFor => {
      if (isSearchFor === 'Alquilar') {
        this.isSearch4 = '2';
      } else if (isSearchFor === 'Comprar') {
        this.isSearch4 = '1';
      } else if (isSearchFor === 'AlquilerCompra') {
        this.isSearch4 = '3';
      }
      this.changeSearch4()
    })
  }

  searchEnd() {
    this.router.navigate(['/inmueblesmain'],
      {
        queryParams: {
          isSearch4: this.isSearch4,
          use: this.myForm.get('use')?.value,
          province: this.myForm.get('province')?.value,
          city: this.myForm.get('city')?.value,
          district: this.myForm.get('district')?.value,
          supObj: {
            surfaceTotalmin: 0,
            surfaceTotalmax: 50000,
            surfacebrmin: 0,
            surfacebrmax: 30000,
            surfacepbmin: 0,
            surfacepbmax: 30000,
            surfaceMezzaninemin: 0,
            surfaceMezzaninemax: 30000,
            surfaceBasement1min: 0,
            surfaceBasement1max: 30000,
            surfaceBasement2min: 0,
            surfaceBasement2max: 30000,
          },
          smoke: false
        }
      }
    );

  }

}
